export default __webpack_public_path__ + "static/media/polar2dtri.c30a85f7.jpg";